// Utils
import localStorageService from '../../../../../utils/services/localStorage/localStorage';

// Constants
const LOCALE_SUGGESTION_DISMISSED_KEY = 'milanote.locale.dismissed';

export const getHasLocaleSuggestionBeenDismissed = (): boolean =>
    !!localStorageService.getItem(LOCALE_SUGGESTION_DISMISSED_KEY);

export const setLocaleSuggestionAsDismissed = (): void =>
    localStorageService.setItem(LOCALE_SUGGESTION_DISMISSED_KEY, true);
